import React from "react";
import { PropertyDetails } from '../../../core/api/models/project';
import { convertPascalCaseToWords } from '../../../core';
import Slider from 'react-slick';
import moment from 'moment';
import { FurnishingDetailsViewOption } from './props';
import { RenderFieldDetails } from "./selected-properties-render-field-details";

interface SelectedPropertiesDropdownTableProps {
    dropdownClick: (event: any, id: string, fieldName: string) => void;
    dropPos: { open: boolean; x: string; y: string; id: string; fieldName: string; } | undefined;
    excludeFloorDetails?: PropertyDetails[];
    floors: any[];
    handleThirdColumnChange: (projectId: string, checked: boolean) => void;
    item: any;
    propertyDetails?: PropertyDetails[];
    onAllSelected: (projectId: string) => void;
    onAllSelectedExcludedFloorPlan: (sel: boolean, projectId: string) => void;
    onAllSelectedExcludeFurnishing: (sel: boolean, projectId: string) => void;
    onAllSelectedExcludePhotoGallery: (sel: boolean, projectId: string) => void;
    onSelect: (propertyId: string) => void;
    onSelectExcludeFloorPlan: (sel: boolean, propertyId: any) => void;
    onSelectExcludeFurnishing: (sel: boolean, propertyId: any) => void;
    onSelectExcludePhotoGallery: (sel: boolean, propertyId: any) => void;
    ordinalSuffixOf: (i: number) => string;
    excludeFurnishingDetails?: PropertyDetails[];
    selectedFloorplanFurnishing?: { [key: string]: string };
    unitDetails: any;
    onUpdateFloorplanFurnishing?: (propertyId: string, value: string) => void;
    excludePhotoDetails?: PropertyDetails[];
    showThirdColumn?: { [key: string]: boolean };
}

const settings = {
    className: "require-slider",
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
};

export function SelectedPropertiesDropdownTable({
    dropdownClick,
    dropPos,
    floors,
    handleThirdColumnChange,
    item,
    onAllSelected,
    onAllSelectedExcludeFurnishing,
    onAllSelectedExcludePhotoGallery,
    onSelect,
    onSelectExcludeFloorPlan,
    selectedFloorplanFurnishing,
    onSelectExcludeFurnishing,
    onSelectExcludePhotoGallery,
    ordinalSuffixOf,
    excludeFloorDetails,
    onAllSelectedExcludedFloorPlan,
    onUpdateFloorplanFurnishing,
    propertyDetails,
    excludePhotoDetails,
    showThirdColumn,
    excludeFurnishingDetails,
    unitDetails }: SelectedPropertiesDropdownTableProps) {
        
        const floorplanFurnishingOptions = [
            {
                name: convertPascalCaseToWords(FurnishingDetailsViewOption.TwoColumn),
                value: FurnishingDetailsViewOption.TwoColumn,
            },
            {
                name: convertPascalCaseToWords(FurnishingDetailsViewOption.SinglePage),
                value: FurnishingDetailsViewOption.SinglePage,
            },
            {
                name: convertPascalCaseToWords(FurnishingDetailsViewOption.ThreeColumn),
                value: FurnishingDetailsViewOption.ThreeColumn,
                disabled: true,
            },
        ];

    return (
        <>
            <div
                className="py-4 pr-4 pl-5"
                style={{ maxWidth: "90vw" }}
            >
                <Slider {...settings}>
                    <div className="border rounded p-2 d-inline-block mr-1 w-auto">
                        <div className="font-sm font-weight-semibold title">
                            Matching Unit
                        </div>
                        <div className="font-xs font-weight-medium text-gray-700">
                            {
                                unitDetails?.filter(
                                    (p: any) =>
                                        p.currentStatus === "available"
                                )?.length
                            }{" "}
                            Available, {unitDetails?.length} Total
                        </div>
                    </div>
                    {floors?.map((fl) => {
                        const availableCount = unitDetails?.filter(
                            (x: any) =>
                                x.currentStatus === "available" &&
                                x.floor === fl
                        )?.length;
                        const totalCount = unitDetails?.filter(
                            (x: any) => x.floor === fl
                        )?.length;

                        return (
                            <>
                                <div className="border rounded p-2 d-inline-block mr-1 w-auto">
                                    {fl === "0" ? (
                                        <div className="font-sm font-weight-semibold title">
                                            Ground Floor
                                        </div>
                                    ) : (
                                        <div className="font-sm font-weight-semibold title">
                                            {ordinalSuffixOf(Number(fl))}{" "}
                                            Floor
                                        </div>
                                    )}
                                    <div className="font-xs font-weight-medium text-gray-700">
                                        {availableCount} Available,{" "}
                                        {totalCount} Total
                                    </div>
                                </div>
                            </>
                        );
                    })}
                </Slider>
            </div>
            <div>
                <table className="table table-bordered w-100 font-sm">
                    <tr>
                        <td
                            className="py-2  px-2   border-bottom px-1"
                            style={{
                                maxWidth: "40px",
                                width: "40px",
                            }}
                        >
                            <div className="">
                                <i
                                    className="icon-close cursor-pointer"
                                    onClick={(e) =>
                                        onAllSelected(item.projectId)
                                    }
                                ></i>
                                <label
                                    htmlFor={`propertyCheck- px-2 -${item.projectId}`}
                                ></label>
                            </div>
                        </td>
                        <td className="py-2 border-bottom">
                            <div className="py-1">Floor</div>
                        </td>
                        <td className="py-2 border-bottom">
                            <div className="py-1">Unit Id</div>
                        </td>
                        <td className="py-2 border-bottom">
                            <div className="py-1">
                                Area (in Sq.Ft)
                            </div>
                        </td>
                        <td className="py-2 border-bottom">
                            <div className="py-1">Interior Type</div>
                        </td>
                        <td className="py-2 border-bottom">
                            <div className="py-1">Quoted Rent</div>
                        </td>
                        <td className="py-2 border-bottom">
                            <div className="py-1">Current Status</div>
                        </td>
                        <td className="py-2 border-bottom">
                            <div className="py-1">Available From</div>
                        </td>
                        <td className="py-2 border-bottom font-sm">
                            <div className="py-1">
                                Contact Details
                            </div>
                        </td>
                        <td className="py-2 border-bottom font-sm">
                            <div className="d-flex align-items-center">
                                <div className="">
                                    <input
                                        type="checkbox"
                                        name={`excludeAllFlrCheck-${item?.projectId}`}
                                        id={`excludeAllFlrCheck-${item?.projectId}`}
                                        onChange={(e) =>
                                            onAllSelectedExcludedFloorPlan(
                                                e.target.checked,
                                                item?.projectId
                                            )
                                        }
                                        checked={
                                            excludeFloorDetails?.filter(
                                                (itemA) =>
                                                    itemA?.projectId ===
                                                    item?.projectId
                                            )?.length ===
                                            propertyDetails?.filter(
                                                (itemB) =>
                                                    itemB?.projectId ===
                                                    item?.projectId
                                            )?.length
                                        }
                                    />
                                    <label
                                        htmlFor={`excludeAllFlrCheck-${item?.projectId}`}
                                    ></label>
                                </div>
                                <div className="py-1">
                                    Exclude Floor Plan
                                </div>
                            </div>
                        </td>
                        <td className="py-2 border-bottom font-sm">
                            <div className="d-flex align-items-center">
                                <div className="">
                                    <input
                                        type="checkbox"
                                        name={`excludePhotoCheck-${item?.projectId}`}
                                        id={`excludePhotoCheck-${item?.projectId}`}
                                        onChange={(e) =>
                                            onAllSelectedExcludePhotoGallery(
                                                e.target.checked,
                                                item?.projectId
                                            )
                                        }
                                        checked={
                                            excludePhotoDetails?.filter(
                                                (itemA) =>
                                                    itemA?.projectId ===
                                                    item?.projectId
                                            )?.length ===
                                            propertyDetails?.filter(
                                                (itemB) =>
                                                    itemB?.projectId ===
                                                    item?.projectId
                                            )?.length
                                        }
                                    />
                                    <label
                                        htmlFor={`excludePhotoCheck-${item?.projectId}`}
                                    ></label>
                                </div>
                                <div className="py-1">
                                    Exclude Photo Gallery
                                </div>
                            </div>
                        </td>
                        <td className="py-2 border-bottom font-sm">
                            <div className="d-flex align-items-center">
                                <div className="">
                                    <input
                                        type="checkbox"
                                        name={`excludeFurnishingCheck-${item?.projectId}`}
                                        id={`excludeFurnishingCheck-${item?.projectId}`}
                                        onChange={(e) =>
                                            onAllSelectedExcludeFurnishing(
                                                e.target.checked,
                                                item?.projectId
                                            )
                                        }
                                        checked={
                                            excludeFurnishingDetails?.filter(
                                                (itemA) =>
                                                    itemA?.projectId ===
                                                    item?.projectId
                                            )?.length ===
                                            propertyDetails?.filter(
                                                (itemB) =>
                                                    itemB?.projectId ===
                                                    item?.projectId
                                            )?.length
                                        }
                                    />
                                    <label
                                        htmlFor={`excludeFurnishingCheck-${item?.projectId}`}
                                    ></label>
                                </div>
                                <div className="py-1">
                                    Exclude Furnishing
                                </div>
                            </div>
                        </td>
                        <td className="py-2 border-bottom font-sm">
                            <div className="py-1">
                                Floorplan & Furnishing Details
                                <div className="mt-1">
                                    <input
                                        type="checkbox"
                                        id={`showThirdColumn-${item.projectId}`}
                                        checked={
                                            showThirdColumn?.[
                                            item.projectId
                                            ] || false
                                        }
                                        onChange={(e) =>
                                            handleThirdColumnChange(
                                                item.projectId,
                                                e.target.checked
                                            )
                                        }
                                    />
                                    <label
                                        htmlFor={`showThirdColumn-${item.projectId}`}
                                        className="font-sm"
                                    >
                                        Three columns per page
                                    </label>
                                </div>
                            </div>
                        </td>
                    </tr>
                    {unitDetails?.map((unit: any) => {
                        const property = unit;
                        const propertyDetailsInformation =
                            unit.propertyDetails;

                        return (
                            <>
                                <tr>
                                    <td
                                        className="py-3 px-2 border-bottom px-0"
                                        style={{
                                            maxWidth: "40px",
                                            width: "40px",
                                        }}
                                    >
                                        <div className="">
                                            <i
                                                className="icon-close cursor-pointer"
                                                onClick={(e) =>
                                                    onSelect(property?.propertyId)
                                                }
                                            ></i>

                                            <label
                                                htmlFor={`propertyCheck-${unit.projectId}-${property?.propertyId}`}
                                            ></label>
                                        </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="">
                                            {property.floor}
                                        </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="">
                                            {property.unitName}
                                        </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="">
                                            {property.area?.toFixed(2)}
                                        </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="">
                                            {property?.interiorType}
                                        </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="">
                                            {property?.quotedRent}{" "}
                                        </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="">
                                            {convertPascalCaseToWords(
                                                property?.currentStatus
                                            )}
                                        </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        {property?.availableFrom &&
                                            property?.availableFrom !==
                                            "1970-01-01T00:00:00.000Z" && (
                                                <div className="">
                                                    {moment(
                                                        property?.availableFrom
                                                    ).format("DD-MM-YYYY")}
                                                </div>
                                            )}
                                    </td>
                                    <td
                                        className="py-2 border-bottom"
                                        style={{
                                            width: "290px",
                                            maxWidth: "290px",
                                        }}
                                    >
                                        <div
                                            role="button"
                                            className="py-1 w-100 font-xs font-weight-semibold position-relative"
                                            onClick={(e) =>
                                                dropdownClick(
                                                    e,
                                                    propertyDetailsInformation?._id,
                                                    "ContactDetails"
                                                )
                                            }
                                        >
                                            {propertyDetailsInformation?.contactDetails
                                                ?.length
                                                ? propertyDetailsInformation
                                                    ?.contactDetails?.length > 2
                                                    ? propertyDetailsInformation.contactDetails
                                                        .slice(0, 2)
                                                        .map((participant: any) =>
                                                            participant
                                                                ? `${participant.contactName ||
                                                                ""
                                                                }`
                                                                : ""
                                                        )
                                                        .join(", ")
                                                    : propertyDetailsInformation?.contactDetails
                                                        ?.map(
                                                            (participant: any) =>
                                                                participant
                                                                    ? `${participant.contactName ||
                                                                    ""
                                                                    }`
                                                                    : ""
                                                        )
                                                        .join(", ")
                                                : ""}
                                            <span className="text-primary cursor-pointer">
                                                {propertyDetailsInformation?.contactDetails
                                                    ?.length > 2
                                                    ? ` +${propertyDetailsInformation
                                                        ?.contactDetails
                                                        ?.length - 2
                                                    }`
                                                    : ""}
                                                {!!propertyDetailsInformation
                                                    ?.contactDetails?.length &&
                                                    propertyDetailsInformation?._id ===
                                                    dropPos?.id &&
                                                    dropPos?.fieldName ===
                                                    "ContactDetails" &&
                                                    dropPos?.open && <RenderFieldDetails fieldName="Contact Details" fieldArrayValues={propertyDetailsInformation?.contactDetails} />
                                                }
                                            </span>
                                        </div>
                                    </td>

                                    <td
                                        className="py-3 px-2 text-center border-bottom px-0"
                                        style={{
                                            maxWidth: "40px",
                                            width: "40px",
                                        }}
                                    >
                                        <div className="">
                                            <input
                                                type="checkbox"
                                                name={`excludeFlrCheck-${property?.propertyId}`}
                                                id={`excludeFlrCheck-${property?.propertyId}`}
                                                onChange={(e) =>
                                                    onSelectExcludeFloorPlan(
                                                        e.target.checked,
                                                        property?.propertyId
                                                    )
                                                }
                                                checked={excludeFloorDetails
                                                    ?.map(
                                                        (exFlritem) =>
                                                            exFlritem?.propertyId
                                                    )
                                                    ?.includes(
                                                        property?.propertyId
                                                    )}
                                            />
                                            <label
                                                htmlFor={`excludeFlrCheck-${property?.propertyId}`}
                                            ></label>
                                        </div>
                                    </td>
                                    <td
                                        className="py-3 px-2 text-center border-bottom px-0"
                                        style={{
                                            maxWidth: "40px",
                                            width: "40px",
                                        }}
                                    >
                                        <div className="">
                                            <input
                                                type="checkbox"
                                                name={`excludePhotoCheck-${property?.propertyId}`}
                                                id={`excludePhotoCheck-${property?.propertyId}`}
                                                onChange={(e) =>
                                                    onSelectExcludePhotoGallery(
                                                        e.target.checked,
                                                        property?.propertyId
                                                    )
                                                }
                                                checked={excludePhotoDetails
                                                    ?.map(
                                                        (exPhotoItem) =>
                                                            exPhotoItem?.propertyId
                                                    )
                                                    ?.includes(
                                                        property?.propertyId
                                                    )}
                                            />
                                            <label
                                                htmlFor={`excludePhotoCheck-${property?.propertyId}`}
                                            ></label>
                                        </div>
                                    </td>
                                    <td
                                        className="py-3 px-2 text-center border-bottom px-0"
                                        style={{
                                            maxWidth: "40px",
                                            width: "40px",
                                        }}
                                    >
                                        <div className="">
                                            <input
                                                type="checkbox"
                                                name={`excludeFurnishingCheck-${property?.propertyId}`}
                                                id={`excludeFurnishingCheck-${property?.propertyId}`}
                                                onChange={(e) =>
                                                    onSelectExcludeFurnishing(
                                                        e.target.checked,
                                                        property?.propertyId
                                                    )
                                                }
                                                checked={excludeFurnishingDetails
                                                    ?.map(
                                                        (exFurnishingItem) =>
                                                            exFurnishingItem?.propertyId
                                                    )
                                                    ?.includes(
                                                        property?.propertyId
                                                    )}
                                            />
                                            <label
                                                htmlFor={`excludeFurnishingCheck-${property?.propertyId}`}
                                            ></label>
                                        </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="py-1">
                                            <select
                                                className="form-control form-control-sm"
                                                value={

                                                    selectedFloorplanFurnishing?.[
                                                    property?.propertyId
                                                    ] || ""
                                                }
                                                onChange={(e) =>
                                                    onUpdateFloorplanFurnishing?.(
                                                        property?.propertyId,
                                                        e.target.value
                                                    )
                                                }
                                                disabled={
                                                    showThirdColumn?.[
                                                    property.projectId
                                                    ]
                                                }
                                            >
                                                {floorplanFurnishingOptions.map(
                                                    (option) => (
                                                        <option
                                                            key={option.value}
                                                            value={option.value}
                                                            disabled={option.disabled}
                                                        >
                                                            {option.name}
                                                        </option>
                                                    )
                                                )}
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                            </>
                        );
                    })}
                </table>
            </div>
        </>
    );
}
